// eslint-disable-next-line @alto/no-pocky-import
import { Link as KKLink } from '@alto/pocky';
import autobind from 'autobind-decorator';
import React from 'react';
import { Link } from 'react-router';

export type Props = {
  readonly trackContactLinkClicked: (trackingKey: string, origin: string) => void;
  readonly trackingKey: string;
  readonly origin: string;
  readonly onClick?: () => void;
  readonly content?: string;
  readonly className?: string;
  readonly params?: Record<string, string>;
};

/**
 * @deprecated use ContactUs from @alto/features instead.
 */
export default class ContactUsLink extends React.PureComponent<Props> {
  static defaultProps = {
    origin: '',
    params: {},
    trackingKey: '',
  };

  // @ts-expect-error error TS1270: Decorator function return type 'void | TypedPropertyDescriptor<unknown>' is not assignable to type 'void | (() => void)'
  @autobind
  handleClick() {
    const { trackingKey, origin, onClick, trackContactLinkClicked } = this.props;

    trackContactLinkClicked(trackingKey, origin);
    if (onClick) {
      onClick();
    }
  }

  render() {
    const { className, content, params } = this.props;

    let url = '/messages';

    if (params && Object.keys(params).length > 0) {
      url += '?';

      for (const key of Object.keys(params)) {
        url += `${key}=${encodeURIComponent(params[key])}&`;
      }
    }

    return (
      <Link
        className={className}
        to={url}
        // eslint-disable-next-line @typescript-eslint/unbound-method
        onClick={this.handleClick}
      >
        <KKLink>{content || 'send us a message'}</KKLink>
      </Link>
    );
  }
}
